// src/app/services/localstorage.service.ts

import { Injectable } from '@angular/core';

import { SafeAny } from '../../types/safe-any';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem(key: string, value: SafeAny): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Error saving to localStorage', error);
    }
  }

  getItem(key: string): SafeAny | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Error reading from localStorage', error);

      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage', error);
    }
  }

  clear(): void {
    localStorage.clear();
  }
}
